import { Component, Input } from '@angular/core';

@Component({
  selector: 'tag-stage-phase',
  templateUrl: './tag-stage-phase.component.html',
  styleUrls: ['./tag-stage-phase.component.scss'],
})
export class RecruitmentTagStagePhaseComponent {
  @Input() type!: string;
}
